import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";
import { Card } from "@/components/ui/card";
import { formatMoney } from "@/lib/constants";

const short = (n) => new Intl.NumberFormat("tr-TR", { notation: "compact", maximumFractionDigits: 1 }).format(n);

export const YearlySpendChart = ({ data }) => (
  <Card className="p-5 border border-slate-200 shadow-sm mb-6" data-testid="village-yearly-chart">
    <h3 className="font-display font-semibold text-slate-900 mb-1">Yıllara Göre Harcamalar</h3>
    <p className="text-xs text-slate-500 mb-4">Çalışma tutarı, yatırım bütçesi, gerçekleşen yatırım ve altyapı harcaması (TL). Altyapı harcaması projenin başlangıç yılına yazılır.</p>
    {data.length === 0 ? (
      <div className="text-sm text-slate-500 py-10 text-center" data-testid="village-yearly-chart-empty">
        Bu köy için henüz harcama kaydı yok.
      </div>
    ) : (
      <div className="h-72">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 4, right: 8, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" vertical={false} />
            <XAxis dataKey="year" tick={{ fontSize: 12, fill: "#475569" }} />
            <YAxis tickFormatter={short} tick={{ fontSize: 11, fill: "#64748B" }} width={56} />
            <Tooltip formatter={(v) => formatMoney(v)} labelFormatter={(l) => `${l} yılı`} />
            <Legend wrapperStyle={{ fontSize: 12, paddingTop: 16 }} />
            <Bar dataKey="work_amount" name="Çalışma Tutarı" fill="#047857" radius={[3, 3, 0, 0]} />
            <Bar dataKey="investment_budget" name="Yatırım Bütçesi" fill="#94A3B8" radius={[3, 3, 0, 0]} />
            <Bar dataKey="investment_actual" name="Gerçekleşen Yatırım" fill="#1D4ED8" radius={[3, 3, 0, 0]} />
            <Bar dataKey="infra_actual" name="Altyapı Harcaması" fill="#D97706" radius={[3, 3, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    )}
  </Card>
);
